import {RouteRecordRaw} from 'vue-router';

export enum ProfileCreationFunnelMode {
    FREELANCER = 'FREELANCER',
    STRATEGY = 'STRATEGY',
}

export enum ProfileCreationStepGroup {
    SIGNUP = 'SIGNUP',
    COMPLETION = 'COMPLETION',
    WAITING_ROOM = 'WAITING_ROOM',
}

export type OldProfileCreationStep = {
    name: string;
    route: string;
    stepNumber: number;
    stepCount: number;
    stepPercentage: number;
    previousStepName: string | null;
    nextStepName: string | null;
    group: ProfileCreationStepGroup;
    component: any;
    trackingName: string;
};

export enum CreationStepName {
    SIGNUP_INTRODUCTION = 'signup_introduction',
    SIGNUP_USE_CASE = 'signup_use_case',
    SIGNUP_HEADLINE = 'signup_headline',
    SIGNUP_EXPERTISE = 'signup_expertise',
    SIGNUP_CATEGORIZATION = 'signup_categorization',
    SIGNUP_FUNCTIONAL_SKILLS = 'signup_functional_skills',
    SIGNUP_INDUSTRY_EXPERTISE = 'signup_industry_expertise',
    SIGNUP_DAILY_RATE = 'signup_daily_rate',
    SIGNUP_LOCALISATION = 'signup_localisation',
    COMPLETION_LINKEDIN = 'completion_linkedin_import',
    COMPLETION_EXPERIENCE = 'completion_experience',
    COMPLETION_EDUCATION = 'completion_education',
    COMPLETION_DESCRIPTION = 'completion_description',
    COMPLETION_RECOMMENDATION = 'completion_recommendation',
    COMPLETION_PRIVACY = 'completion_privacy',
    COMPLETION_SUBMIT_APPLICATION = 'completion_submit_application',
    WAITING_ROOM = 'waiting_room',
}

export enum MaltClassicStepTrackingName {
    SIGNUP_HEADLINE = 'headline',
    SIGNUP_CATEGORIZATION = 'categorization',
    SIGNUP_EXPERTISE = 'expertise',
    SIGNUP_FUNCTIONAL_SKILLS = 'skills',
    SIGNUP_DAILY_RATE = 'daily-rate',
    SIGNUP_LOCALISATION = 'localisation',
    COMPLETION_LINKEDIN = 'linkedin-import',
    COMPLETION_EXPERIENCE = 'work-experience',
    COMPLETION_EDUCATION = 'education',
    COMPLETION_DESCRIPTION = 'description',
    COMPLETION_RECOMMENDATION = 'recommendation',
    COMPLETION_PRIVACY = 'privacy',
}

export enum MaltStrategyStepTrackingName {
    SIGNUP_INTRODUCTION = 'introduction',
    SIGNUP_USE_CASE = 'use-case',
    SIGNUP_HEADLINE = 'headline',
    SIGNUP_EXPERTISE = 'expertise',
    SIGNUP_CATEGORIZATION = 'categorization',
    SIGNUP_INDUSTRY_EXPERTISE = 'industry-expertise',
    SIGNUP_DAILY_RATE = 'daily-rate',
    SIGNUP_LOCALISATION = 'localisation',
    COMPLETION_LINKEDIN = 'linkedin-import',
    COMPLETION_EXPERIENCE = 'work-experience',
    COMPLETION_EDUCATION = 'education',
    COMPLETION_DESCRIPTION = 'description',
    COMPLETION_RECOMMENDATION = 'recommendation',
    COMPLETION_PRIVACY = 'privacy',
    COMPLETION_SUBMIT_APPLICATION = 'submit-application',
    WAITING_ROOM = 'waiting_room',
}

export enum OldCreationStepTrackingName {
    SIGNUP_HEADLINE = 'headline',
    SIGNUP_CATEGORIZATION = 'categorization',
    SIGNUP_EXPERTISE = 'expertise',
    SIGNUP_LOCALISATION = 'localisation',
    COMPLETION_DESCRIPTION = 'description',
    COMPLETION_RECOMMENDATION = 'recommendation',
    COMPLETION_PRIVACY = 'privacy',
}

export type ProfileCreationStep = {
    name: string;
    route: string;
    stepNumber: number;
    stepCount: number;
    previousStepName: CreationStepName | null;
    nextStepName: CreationStepName | null;
    group: ProfileCreationStepGroup;
    component: any;
    trackingName: string;
};

export type RoutesConfig = {
    routes: RouteRecordRaw[];
    creationFirstStep: string;
    completionFirstStep: string;
};

export type OldProfileCreationSteps = OldProfileCreationStep[];
export type ProfileCreationSteps = ProfileCreationStep[];
